<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12 primary white--text">
							<v-toolbar-title>
								<v-img
									class="mx-auto mt-5"
									alt="Orixe Logo"
									:src="require('../../assets/Logo_Header_White.svg')"
									width="40%"
								/>
								<h1 class="mt-2 ml-5 white--text text-left">
									Email Verification
								</h1>
							</v-toolbar-title>
							<v-card-actions>
								<v-btn to="/login" class="ma-3">Go to login page</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<test-error />
	</v-app>
</template>

<script>
import store from "../../store"
import LoadingState from "../../consts/LoadingState"

export default {
	name: "Email Verification",
	data() {
		return {
			token: null,
			verified: true,
		}
	},
	methods: {},
	mounted() {
		this.token = this.$route.query.token
		store
			.dispatch("user/verifyEmail", {
				token: this.token,
			})
			.then(() => {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"Email successfully verified! You may now log in.",
					{ root: true }
				)
				this.verified = true
			})
			.catch((err) => {
				this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, err, {
					root: true,
				})
			})
	},
}
</script>
